import { NavLink } from "react-router-dom";
import { Home, Dumbbell, Apple, Users, ShoppingBag } from "lucide-react";

const tabs = [
  { to: "/home", label: "Home", icon: Home, testid: "nav-home" },
  { to: "/workouts", label: "Workouts", icon: Dumbbell, testid: "nav-workouts" },
  { to: "/nutrition/scanner", label: "Nutrition", icon: Apple, testid: "nav-nutrition" },
  { to: "/community", label: "Community", icon: Users, testid: "nav-community" },
  { to: "/marketplace", label: "Shop", icon: ShoppingBag, testid: "nav-shop" },
];

export default function BottomNav() {
  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 left-0 right-0 bg-white/85 backdrop-blur-xl border-t border-line2 px-2"
      style={{ paddingBottom: "env(safe-area-inset-bottom)", zIndex: 40 }}
    >
      <ul className="flex items-stretch justify-between max-w-2xl mx-auto h-16">
        {tabs.map((t) => (
          <li key={t.to} className="flex-1">
            <NavLink
              to={t.to}
              data-testid={t.testid}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center h-full gap-1 transition-all ${
                  isActive ? "text-[color:var(--text-primary)]" : "text-[color:var(--text-muted)]"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <t.icon
                    size={22}
                    strokeWidth={isActive ? 2.4 : 1.8}
                    style={isActive ? { color: "var(--accent-blue)" } : undefined}
                  />
                  <span className="text-[10.5px] tracking-wide" style={isActive ? { color: "var(--text-primary)", fontWeight: 600 } : undefined}>
                    {t.label}
                  </span>
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
